module.exports = ".loader {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  top: 0;\n  left: 0;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  z-index: 998;\n  background-color: var(--grey-bg); }\n  .loader div {\n    background-color: var(--primary); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main